export default __webpack_public_path__ + "static/physioassist2-d5050ba7ae2711c986fefbf03470a8d7.png";